<ngx-ui-loader [loaderId]="'dashboard'"></ngx-ui-loader>
<div class="row ">
  <div class="col-md-12">
    <h2 class="mb-0">
      <mat-card>
        <mat-card-content style="display: flex; justify-content: space-between; align-items: center;">
          <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseOne"
            aria-expanded="true" aria-controls="collapseOne">
            <i class="fa fa-filter"></i> Filter by Country, State, City...
          </button>
        </mat-card-content>
      </mat-card>

    </h2>

  </div>

</div>

<div class="row" style="margin-top: 1%;">

  <div class="col-md-3">
    <mat-card style="box-shadow: 0px 0px 5px 5px #888888;border-radius: 0px 0px 0px 0px; border: 0px solid #FFFFFF; ">
      <mat-card-header style="background-color: red;padding: 0px;">
        <b style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);color: #FFFFFF;">PUMP STATUS</b>
      </mat-card-header>
      <mat-card-content>

        <table style="margin-left: 10%;font-size: larger;font-weight: bold;">


          <tbody *ngIf="tileData" style="width: 70%; ">
            <tr>
              <td>
                <p><span style="color: rgb(0, 255, 174);">●</span>Total Pump </p>
              </td>
              <td>
                <a><b style="cursor: pointer; color: rgb(239, 128, 0)" class="totalTransformerr"
                    (click)="popupTable('total','')">&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;{{tileData.totalpump}}</b></a>
              </td>
            </tr>

            <tr>
              <td>
                <p><span style="color: green">●</span>Connected Pump </p>
              </td>
              <td>
                <a><b class="onlinee" style="cursor: pointer; color: rgb(239, 128, 0)"
                    (click)="popupTable('online','')">&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;{{tileData.onlinePump}}</b></a>
              </td>
            </tr>

            <tr>
              <td>
                <p><span style="color: red;">●</span>Alert Pump</p>
              </td>
              <td>
                <a><b class="alertt" style="cursor: pointer; color: rgb(239, 128, 0)"
                    (click)="popupTable('alert','')">&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;{{tileData.alertpump}}</b></a>

              </td>
            </tr>

            <tr>
              <td>
                <p><span style="color: rgb(0, 242, 255);">●</span>Normal Pump</p>
              </td>
              <td>
                <a><b class="normall" style="cursor: pointer; color: rgb(239, 128, 0)"
                    (click)="popupTable('normal','')">&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;{{tileData.normalPump}}</b></a>
              </td>
            </tr>


            <tr>
              <td>
                <p><span style="color: black;">●</span>Disconnected Pump </p>
              </td>
              <td>
                <a><b class="offlinee" style="cursor: pointer; color: rgb(239, 128, 0)"
                    (click)="popupTable('offline','')">&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;{{tileData.offlinePump}}</b></a>
              </td>
            </tr>

          </tbody>
        </table>


      </mat-card-content>
    </mat-card>


  </div>
  <!--detail Location Card-->
  <div class="col-md-9" style="padding-left: 0px; margin: 0px;">
    <div class="row no-gutters">
      <div class="col-md-2">
        <mat-card style="height: 24vh; border-radius: 0px 0px 0px 0px; border: 0px solid #FFFFFF;">
          <div style=" height:25vh;min-height:25vh; " id="sumpLevel"></div>
          <!--<ejs-circulargauge id="circular-containers" height='200px' width='200px'>
            <e-axes>
              <e-axis [lineStyle]="{ color: sumplevel <= 30 ? 'red' : 'Orange' }">
                <e-ranges>
                  <e-range start=0 [end]="sumplevel" radius="108%"></e-range>
                </e-ranges>
                <e-annotations>
                  
                  <e-annotation content="{{ sumplevel }}" [angle]="90" radius="50%" [style]="{ color: sumplevel >= 450 ? 'red' : 'Orange', fontFamily: 'Arial', fontSize: '12px' }"></e-annotation>
                </e-annotations>
                <e-pointers>
                 
                  <e-pointer [value]="sumplevel" color="#FF5733" type="RangeBar" markerShape="Circle" radius="100%" [markerHeight]="markerSize" [markerWidth]="markerSize"></e-pointer>
                  <e-pointer [value]="sumplevel" [color]="sumplevel >= 450 ? 'red' : 'Orange'" radius="100%" pointerWidth=10 [cap]="pointerCap"></e-pointer>
                  <e-pointer [value]="sumplevel" [color]="sumplevel >= 450 ? 'red' : 'Orange'" radius="100%" pointerWidth=10 [cap]="pointerCap"></e-pointer>
                </e-pointers>
              </e-axis>
            </e-axes>
          </ejs-circulargauge>
          <plotly-plot [data]="sumpvalues" [layout]="graphsumplevel.layout" [config]="graphsumplevel.config"
            [useResizeHandler]="true" [style]="{ width: '100%', height: '150%', position: 'relative' }">
          </plotly-plot>-->
        </mat-card>
      </div>
     <!-- <div class="col-md-3">
        <mat-card
          style="height: 24vh; border-radius: 0; border: 0; display: flex; align-items: center; justify-content: center;">
          <div style="padding: 17% 1% 17% 1%;">
          <table style="font-size: 90%; font-weight: bold; width: 90%; text-align: left;">
            <tbody *ngIf="tileData">
              <tr>
                <td style="white-space: nowrap;">
                  <span style="color: rgb(63, 108, 244);">●</span>&nbsp;Water Flow
                </td>
                <td style="white-space: nowrap;">
                  <a style="cursor: pointer; color: rgb(239, 128, 0);" >
                    <b>&nbsp;&nbsp;:&nbsp;{{waterLeveld}}&nbsp;M3/Hr</b>
                  </a>
                </td>
              </tr>
              <tr>
                <td style="white-space: nowrap;">
                  <span [ngStyle]="{'color': pumponedp > 0 ? 'green' : 'red'}">●</span>&nbsp;Pump 1 DP Low
                </td>
                <td style="white-space: nowrap;">
                  <a style="cursor: pointer;" [ngStyle]="{'color': pumponedp > 0 ? 'green' : 'red'}">
                    <b>&nbsp;&nbsp;:&nbsp;&nbsp;{{pumponedp}}</b>
                  </a>
                  
                </td>
              </tr>
              <tr>
                <td style="white-space: nowrap;">
                  <span [ngStyle]="{'color': pumptwodp > 0 ? 'green' : 'red'}">●</span>&nbsp;Pump 2 DP Low
                </td>
                <td style="white-space: nowrap;">
                  <a style="cursor: pointer; " [ngStyle]="{'color': pumptwodp > 0 ? 'green' : 'red'}" >
                    <b>&nbsp;&nbsp;:&nbsp;&nbsp;{{pumptwodp}}</b>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </mat-card>
      </div> -->
      <div class="col-md-4">
        <mat-card style="height: 24vh; border-radius: 0; border: 0; overflow: hidden;">
          <div style="padding: 4% 1% 17% 7%;">
            <div class="row" style="padding-bottom: 1%;">
              <div class="col-md-6" style="font-size: small; font-weight: bold; width: 90%; text-align: left; white-space: nowrap;">
                <span style="color: #ebef0c;">●</span>&nbsp;Current Water Flow&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:
              </div>
              <div class="col-md-5" >
                <b  style="color: rgb(255, 145, 0);;">{{waterLeveld}}&nbsp;m³/h</b>
              </div>
            </div>
            <div class="row" style="padding-bottom: 1%;">
              <div class="col-md-6" style="font-size: small; font-weight: bold; width: 90%; text-align: left; white-space: nowrap;">
                <span style="color: rgb(56, 91, 179);">●</span>&nbsp;Today's Water Flow&nbsp;:
              </div>
              <div class="col-md-5" >
                <b style="color: rgb(255, 145, 0);">{{totalWaterFlow}}&nbsp;m³</b>
              </div>
            </div>
            <div class="row" style="padding-bottom: 1%;">
              <div class="col-md-8" style="font-size: small; font-weight: bold; width: 90%; text-align: left; white-space: nowrap;">
                <span style="color: rgb(12, 239, 231);">●</span>&nbsp; Pump 1 Discharge Pressure Low&nbsp;&nbsp;:
              </div>
              <div class="col-md-4" >
                &nbsp;&nbsp;&nbsp;<b [ngStyle]="{color: pump1dplowimg == 'NO'? 'green':'red'}">{{pump1dplowimg}}</b>
              </div>
            </div>
      
            <div class="row" style="padding-bottom: 1%;">
              <div class="col-md-8" style="font-size: small; font-weight: bold; width: 90%; text-align: left; white-space: nowrap;">
                <span style="color: rgb(91, 12, 239);">●</span>&nbsp;Pump 2 Discharge Pressure Low&nbsp;&nbsp;:
              </div>
              <div class="col-md-4" >
                &nbsp;&nbsp;&nbsp;<b [ngStyle]="{color: pump2dplowimg == 'NO'? 'green':'red'}">{{pump2dplowimg}}</b>
               <!--<img src="{{pump2dplowimg}}" height="80%" width="76%">-->
              </div>
            </div>
            <div class="row" style="padding-bottom: 1%;">
              <div class="col-md-8" style="font-size: small; font-weight: bold; width: 90%; text-align: left; white-space: nowrap;">
                <span style="color: rgb(91, 12, 239);">●</span>&nbsp;Lightning Transformer Feedback&nbsp;&nbsp;:
              </div>
              <div class="col-md-4" >
                <img src="../assets/images/{{ lightningTransformerFeedback == 1 ? 'greenSwitch.png' : 'redSwitch.png' }}" style="width: 76%; height: 90%;">
              </div>
            </div>
          </div>
        </mat-card>
      </div>




      <div class="col-md-3">
        <mat-card
          style="height: 24vh; border-radius: 0px 0px 0px 0px; border: 0px solid #FFFFFF; display: flex; flex-direction: column; justify-content: center; align-items: center;">
          <b style=" text-align: center; text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); color: #030303;">Transformer
            Buchholz act</b>
          <img src="{{ buchholz == 0 ? '../assets/images/green.png' : '../assets/images/red.png' }}" alt="Image"
            class="blinking-image" style="max-width: 100%; max-height: 83%; display: block; margin: 0 auto;">
        </mat-card>
      </div>


      <div class="col-md-3">
        <mat-card style="height: 24vh; border-radius: 0; border: 0; overflow: hidden;">
          <div style="padding: 17% 1% 17% 7%;">
            <div class="row">
              <div class="col-md-6" style="font-size: small; font-weight: bold; width: 90%; text-align: left; white-space: nowrap;">
                <span style="color: rgb(235, 239, 12);">●</span>&nbsp; AB Switch Status
              </div>
              <div class="col-md-5" style="display: flex; justify-content: right;">:&nbsp;&nbsp;
                <img src="../assets/images/greenSwitch.png" alt="Green Switch" style="width: 76%; height: 90%;" *ngIf="abswitch == 1">
                <img src="../assets/images/redSwitch.png" alt="Red Switch" style="width: 76%; height: 90%;" *ngIf="abswitch == 0">
              </div>
            </div>
      
            <div class="row">
              <div class="col-md-6" style="font-size: small; font-weight: bold; width: 90%; text-align: left; white-space: nowrap;">
                <span style="color: rgb(12, 239, 231);">●</span>&nbsp; Pump 1 Status
              </div>
              <div class="col-md-5" style="display: flex; justify-content: right;">:&nbsp;&nbsp;
                <img src="../assets/images/greenSwitch.png" alt="Green Switch" style="width: 76%; height: 90%;" *ngIf="pumponestatus == 1">
                <img src="../assets/images/redSwitch.png" alt="Red Switch" style="width: 76%; height: 90%;" *ngIf="pumponestatus == 0">
              </div>
            </div>
      
            <div class="row">
              <div class="col-md-6" style="font-size: small; font-weight: bold; width: 90%; text-align: left; white-space: nowrap;">
                <span style="color: rgb(91, 12, 239);">●</span>&nbsp; Pump 2 Status
              </div>
              <div class="col-md-5" style="display: flex; justify-content: right;">:&nbsp;&nbsp;
                <img src="../assets/images/greenSwitch.png" alt="Green Switch" style="width: 76%; height: 90%;" *ngIf="pumptwostatus == 1">
                <img src="../assets/images/redSwitch.png" alt="Red Switch" style="width: 76%; height: 90%;" *ngIf="pumptwostatus == 0">
              </div>
            </div>

          
            
            
          </div>
        </mat-card>
      </div>
      


    </div>
  </div>


  <!--Map LOcation 4Card-->


</div>

<!-- Graph -->
<div class="row" style="margin-top: 1%;">
  <div class="col-md-3">
    <mat-card
      style="overflow: auto;height:53vh;box-shadow: 0px 0px 5px 5px #888888;border-radius: 0px 0px 0px 0px; border: 0px solid #FFFFFF; ">
      <mat-card-header style="position: sticky;background-color: red;padding: 0px;width:217%">
        <b style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);color: #FFFFFF;">Live Alerts</b>
      </mat-card-header>
      <mat-card-content>
        <ng-container>
          <table class="alerts-table" id="alerttabledata">
            <thead>
              <tr style=" width: fit-content;  position: sticky;">
                <th>Pump ID</th>
                <th>Timestamp</th>
                <th>Parameter</th>
                <th>Actual Value</th>
                <th>Threshold Value</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let alertdata of alertdata" class="scrolling-text">
                <td>{{ alertdata.pump_id }}</td>
                <td>{{ alertdata.Timestamp }}</td>
                <td>{{ formatTitle(alertdata.Parametersname)}}</td>
                <td style="text-align: center;">{{ alertdata.Atualvalue }}</td>
                <td style="text-align: center;">{{ alertdata.Thresholdvalue }}</td>
              </tr>
            </tbody>
          </table>
        </ng-container>
      </mat-card-content>
    </mat-card>


  </div>

  <div class="col-md-9" style="padding-left:0px">
    <mat-card
      style="height: 100%; box-shadow: 0px 0px 5px 5px #888888; border-radius: 0px; border: 0px solid #FFFFFF; position: relative;">
      <div style="width:98%;position: absolute; top: 1%; left: 1%; z-index: 1; ">
        <mat-form-field style="width: 12%;
            position: absolute;
            top: 115%;">
          <mat-label>Select Pump</mat-label>
          <mat-select [(ngModel)]="selectedpump" (ngModelChange)="getGraphData(selectedpump)">
            <mat-option *ngFor="let option of pumpIdsArray" [value]="option">
              {{ option }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div style="display: flex;overflow-x: auto;">
          <button mat-button style="min-width: 120px; background-color: #f44336; color: white;"
            (click)="updateSelected('motorrphasetemperature')">Phase Temp</button>
          <button mat-button style=" margin-left: 10px;min-width: 100px; background-color: #2196f3; color: white;"
            (click)="updateSelected('pumpcurrent')">Current</button>
          <button mat-button style="margin-left: 10px; min-width: 100px; background-color: #4caf50; color: white;"
            (click)="updateSelected('motordetemperature')">De Temp</button>
          <button mat-button style="margin-left: 10px; min-width: 100px; background-color: #ff9800; color: white;"
            (click)="updateSelected('motorndetemperature')">Nde Temp</button>
          <button mat-button style="margin-left: 10px; min-width: 175px; background-color: #4caf50; color: white;"
            (click)="updateSelected('pumpdplow')">Discharge Pressure Low</button>
          <button mat-button style="margin-left: 10px; min-width: 100px; background-color: #ff9800; color: white;"
            (click)="updateSelected('overload')" [ngClass]="{'pulsating-button': overload >= 1}">OverLoad</button>
          <button mat-button style="margin-left: 10px; min-width: 100px; background-color: #59d6aa; color: white;"
            (click)="updateSelected('Water_Flow')">Water Flow</button>
          <button mat-button style="margin-left: 10px; min-width: 100px; background-color: #834496; color: white;"
            (click)="updateSelected('Sump_Level')">Sump Level</button>
          <button mat-button style="margin-left: 10px; min-width: 140px; background-color: #f44336; color: white;"
            (click)="updateSelected('pumponffeedback')">Pump Feedback</button>
        </div>
      
      </div>
      <div style="display: flex;
      top: 13%;
      position: relative;
      justify-content: center;
      z-index: 3;font-weight:bolder;">{{selectedpump}} Running Time :
        {{totalPumpOnTimeInHours}}H:{{totalPumpOnTimeInMinutes}}M:{{totalPumpOnTimeInSeconds}}S 
      </div>
      <div *ngIf="jsonReadings; else noDataTemplate">
        <ngx-ui-loader [loaderId]="'graphloader'"></ngx-ui-loader>
        <plotly-plot [data]="data" [layout]="graph.layout" [config]="graph.config" [useResizeHandler]="true"
                     [style]="{ width: '100%', height: 'calc(100% - 27px)', position: 'relative', top: '30px' }">
        </plotly-plot>
      </div>
      <ng-template #noDataTemplate>
        <div class="no-data-container">
          <p style="font-weight: bolder;">No data to show</p>
        </div>
      </ng-template>
      
    </mat-card>
  </div>

</div>